import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// Connects to data-controller="notification-popup"
// Auto-shows a Bootstrap modal on connect, and fires a POST to mark-url when the modal closes.
export default class extends Controller {
  static values = { markUrl: String }

  connect() {
    this.marked = false
    this.modal = new Modal(this.element, {
      backdrop: 'static',
      keyboard: true,
    })
    this.boundHidden = this.handleHidden.bind(this)
    this.element.addEventListener('hidden.bs.modal', this.boundHidden)
    this.modal.show()
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.boundHidden)
    if (this.modal) {
      this.modal.dispose()
    }
  }

  handleHidden() {
    if (this.marked) return
    this.marked = true

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.markUrlValue, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': token || '',
        'Accept': 'text/html',
      },
    })
  }
}
